import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Lashmaker from './views/Lashmaker'
import Impostazioni from './views/Impostazioni.vue'
import Servizi from './views/Servizi'
import Calendario from './views/Calendario'
import Pagamento from './views/Pagamento'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/lashmaker',
      name: "LashMaker's",
      component: Lashmaker
    },
/*    {
      path: '/trattamenti',
      name: "Trattamenti",
      component: Trattamenti
    },
*/
    {
      path: '/servizi',
      name: "Servizi",
      component: Servizi
    },
    {
      path: '/impostazioni',
      name: "impostazioni",
      component: Impostazioni
    },    
    {
      path: '/calendario',
      name: "Calendario",
      component: Calendario
    },
    {
      path: '/pagamento/:appuntamento',
      name: "pagamento",
      component: Pagamento,
      props: true
    }    
  ]
})
